var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "footer" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "footer-pc d-none d-lg-block" }, [
        _c("div", { staticClass: "footer-main" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "footer-right" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "footer-copyright footer-company" }, [
              _vm._v("\n            广播电视节目制作经营许可证编号："),
              _c(
                "a",
                {
                  attrs: {
                    href: require("@/assets/images/zizhi.png"),
                    target: "_blank",
                  },
                },
                [_vm._v("(苏)字第03385号")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer-copyright" }, [
              _vm._v(
                "\n            公安备案号：苏公网安备32028102003326号\n          "
              ),
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "footer-address" }, [
              _vm._v(
                "\n            运营单位：江苏三九互网络科技有限公司\n          "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(3),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-mobile d-block d-lg-none" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "footer-icp-mobile" }, [
          _vm._v("\n        广播电视节目制作经营许可证编号："),
          _c(
            "a",
            {
              attrs: {
                href: require("@/assets/images/zizhi.png"),
                target: "_blank",
              },
            },
            [_vm._v("(苏)字第03385号")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer-icp-mobile" }, [
          _vm._v("\n        公安备案号：苏公网安备32028102003326号\n      "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer-company-mobile" }, [
          _vm._v("\n        江苏三九互网络科技有限公司 版权所有\n      "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-left" }, [
      _c("img", {
        staticClass: "footer-logo",
        attrs: { src: require("@/assets/images/3975.png"), alt: "3975游戏" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-links" }, [
      _c(
        "a",
        { attrs: { href: "https://www.3975.com/about", target: "_blank" } },
        [_vm._v("关于我们")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.3975.com/contact/index",
            target: "_blank",
          },
        },
        [_vm._v("联系我们")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.3975.com/public/webnew/39XY-2.html",
            target: "_blank",
          },
        },
        [_vm._v("用户协议")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "https://www.3975.com/zjjh/index/", target: "_blank" },
        },
        [_vm._v("家长监护")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.3975.com/personal/renzhen/",
            target: "_blank",
          },
        },
        [_vm._v("实名认证")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.3975.com/ticket/index/",
            target: "_blank",
          },
        },
        [_vm._v("申请开票")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "https://www.3975.com/yinsi/index", target: "_blank" },
        },
        [_vm._v("隐私政策")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.3975.com/worksystem/index",
            target: "_blank",
          },
        },
        [_vm._v("企业责任制度")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-company" }, [
      _vm._v(
        "\n            江苏三九互网络科技有限公司 版权所有 信息产业部备案号："
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://beian.miit.gov.cn/#/Integrated/index",
            target: "_blank",
          },
        },
        [_vm._v("苏ICP备16021564号-206")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-certificates" }, [
      _c(
        "a",
        {
          staticClass: "cert-item",
          attrs: { href: "https://www.js12377.cn/", target: "_blank" },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/images/legal-ico-jb.png"),
              alt: "江苏省互联网主办者备案不良信息举报",
            },
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v("江苏省互联网违法和"),
            _c("br"),
            _vm._v("有害不良信息举报"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "cert-item",
          attrs: { href: "https://www.12377.cn/", target: "_blank" },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/images/legal-ico-2.png"),
              alt: "不良信息举报中心",
            },
          }),
          _vm._v(" "),
          _c("span", [_vm._v("不良信息"), _c("br"), _vm._v("举报中心")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "cert-item",
          attrs: {
            href: "https://www.3975.com/public/webnew/foot/dengji.html",
            target: "_blank",
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/images/legal-ico-3.png"),
              alt: "企业信用认证书",
            },
          }),
          _vm._v(" "),
          _c("span", [_vm._v("企业信用评级"), _c("br"), _vm._v("认证书")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "cert-item",
          attrs: {
            href: "http://www.beian.gov.cn/portal/registerSystemInfo",
            target: "_blank",
          },
        },
        [
          _c("img", {
            attrs: { src: require("@/assets/images/legal-ico-5.png"), alt: "" },
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v("公网备案信息"),
            _c("br"),
            _vm._v("32028102003326号"),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-icp-mobile" }, [
      _vm._v("\n        信息产业部备案号："),
      _c(
        "a",
        {
          attrs: {
            href: "https://beian.miit.gov.cn/#/Integrated/index",
            target: "_blank",
          },
        },
        [_vm._v("苏ICP备16021564号-206")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }